import { createFileRoute } from '@tanstack/react-router';

import { NetworkTemplatePage } from '../features/a2v/networkTemplate/components/NetworkTemplatePage/NetworkTemplatePage';

export const Route = createFileRoute('/a2v/network-template')({
  component: NetworkTemplatePage,
});
